// Duits (de-DE), reminders (de oproep op het bord): zelfde vorm als reminders.nl.ts. Kort en
// eenvoudig voor kinderen. Wat ontbreekt valt terug op het Nederlands.
export const kioskRemindersDe = {
    ok: 'Okay!',
    /** Rustig, buiten het thema Kinderen. */
    okCalm: 'Okay',
    speak: '{names}, {title}!',
    context: '{title} um {time}',
    hint: 'Gleich: {title} · {time}',
    and: 'und',
    dialog: 'Erinnerung: {title}',
    okFor: 'Okay, {name}',
    checklist: 'Mit in die Tasche',
    checklistLeft: 'noch {count}',
    checklistDone: 'Alles drin!',
    checklistDoneCalm: 'Alles ist eingepackt',
    checklistItem: '{label}, {name}',
    checklistItemDone: '{label} ist drin',
    taskContext: 'Aufgabe um {time}',
};
//# sourceMappingURL=reminders.de.js.map